import { Flex } from '@acsbe/ui';
import styled from 'styled-components';
import { BillingMethod } from '../../../context/BillingContext';

export const BorderedFlex = styled(Flex)<{
  setBorderBottom?: boolean;
}>`
  border-bottom: ${(props) =>
    props.setBorderBottom ? '1px solid #CBD2E1' : 'none'};
`;

export function getPaymentMethodState(card: BillingMethod) {
  const isDefault = card.favorite;
  const isInvalidCard = card.invalid;
  const isExpiredCard = card.isExpiredCard;
  const expiresSoon = card.daysToExpire < 90 && !card.isExpiredCard;
  const hasGraceLicense = card.graceLicenses > 0;
  const hasActiveLicenses = card.activeLicenses > 0;
  const isZipInvalid = card.isZipInvalidByCountry;
  const isDeclinedCard = isInvalidCard && isExpiredCard;
  const isDeclinedCardOrExpiredCard = isInvalidCard || isExpiredCard;
  const billingHasLicenses = hasGraceLicense || hasActiveLicenses;
  const cardIsInvalidOrZipInvalid = isDeclinedCardOrExpiredCard || isZipInvalid;
  const cardZipCodeIsInvalidAndNotInvalidOrExpired =
    isZipInvalid && !isDeclinedCardOrExpiredCard;
  const canBeSetAsDefault = !isDeclinedCardOrExpiredCard && !isZipInvalid;
  const isZipInvalidAndNotHasGraceLicenses = isZipInvalid && !hasGraceLicense;
  const canUpdateZipCodeFromAction =
    !isDeclinedCardOrExpiredCard && isZipInvalidAndNotHasGraceLicenses;
  const canUpdateZipCodeFromBillingCard =
    isDeclinedCardOrExpiredCard || isZipInvalidAndNotHasGraceLicenses;

  return {
    isDefault,
    isInvalidCard,
    isExpiredCard,
    expiresSoon,
    hasGraceLicense,
    hasActiveLicenses,
    isDeclinedCard,
    isDeclinedCardOrExpiredCard,
    billingHasLicenses,
    isZipInvalid,
    cardIsInvalidOrZipInvalid,
    cardZipCodeIsInvalidAndNotInvalidOrExpired,
    canBeSetAsDefault,
    isZipInvalidAndNotHasGraceLicenses,
    canUpdateZipCodeFromAction,
    canUpdateZipCodeFromBillingCard,
  };
}
